import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PwaInstallService } from './pwa-install.service';

@Component({
  selector: 'app-pwa-install-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './pwa-install-dialog.html',
  styleUrl: './pwa-install-dialog.scss',
})
export class PwaInstallDialog {
  private readonly dialogRef = inject(MatDialogRef<PwaInstallDialog>);
  private readonly pwaInstallService = inject(PwaInstallService);

  async instalar(): Promise<void> {
    const accepted = await this.pwaInstallService.promptInstall();
    this.dialogRef.close(accepted);
  }

  depois(): void {
    this.pwaInstallService.dismissInstallDialog();
    this.dialogRef.close(false);
  }
}
